import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/react";

import "./index.css";
import App from "./App";
import ApiAuthBridge from "./auth/ApiAuthBridge";
import AppUserProvider from "./auth/AppUserProvider";

/**
 * The Clerk publishable key.
 *
 * Publishable keys are not secrets — they ship to the browser by design — but
 * they are read from the environment so that test and live Clerk instances are
 * a deployment setting rather than a code change. The **secret** key and the
 * webhook signing secret must never appear here or in any REACT_APP_* variable:
 * anything with that prefix is compiled into the bundle and is public.
 */
const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const missingKeyStyle = {
  display: "grid",
  placeItems: "center",
  gap: "12px",
  minHeight: "100vh",
  padding: "24px",
  background: "#0c0d0f",
  color: "#f6f7f9",
  fontFamily: "system-ui, sans-serif",
  textAlign: "center",
};

const root = ReactDOM.createRoot(document.getElementById("root"));

if (!publishableKey) {
  // Failing loudly beats rendering an app where every request is silently
  // unauthenticated.
  root.render(
    <div style={missingKeyStyle}>
      <h1 style={{ margin: 0, fontSize: "1.2rem" }}>Clerk is not configured</h1>
      <p style={{ maxWidth: "44ch", color: "#8d9199", lineHeight: 1.6 }}>
        Set <code>REACT_APP_CLERK_PUBLISHABLE_KEY</code> in the frontend
        environment and rebuild. See <code>frontend/.env.example</code>.
      </p>
    </div>
  );
} else {
  root.render(
    <React.StrictMode>
      <ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/sign-in">
        <ApiAuthBridge />
        <AppUserProvider>
          <App />
        </AppUserProvider>
      </ClerkProvider>
    </React.StrictMode>
  );
}
